import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=659f0bf7&scoped=true"
import script from "./AddBankAccount.vue?vue&type=script&lang=js"
export * from "./AddBankAccount.vue?vue&type=script&lang=js"
import style0 from "./AddBankAccount.vue?vue&type=style&index=0&id=659f0bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f0bf7",
  null
  
)

export default component.exports